import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons';

export const TriangleCloseIcon = () => (
    <div className="expansion-panel-icon">
        <FontAwesomeIcon icon={faCaretRight} />
    </div>
)
export default TriangleCloseIcon;




// WEBPACK FOOTER //
// ./src/components/icons/TriangleCloseIcon.js